import React from 'react';
import { Switch } from 'react-router-dom';
import { VariaveisAmbiente } from 'ambiente';
import { CapturarErros, Notificacoes, Route } from 'components';
import { PullToRefreshContainer } from './pull-to-refresh-container/pull-to-refresh-container';
import { LoginRoute } from './login-route';
import { ConviteUsuarioPage } from 'views/pages/public/convite-empresa/convite-empresa-page';
import { EmpresaTema } from 'services/providers/empresa-tema';
import { NovoCadastroPage } from 'views/pages/public/novo-cadastro';
import { DialogModaisPublic } from 'components/dialogs/dialog-modais-public/dialog-modais-public';

export const RouterMain = () => {

  return (
    <PullToRefreshContainer>
      <EmpresaTema>
        <CapturarErros>
          <Notificacoes>
            <Switch>
              <Route
                titulo={VariaveisAmbiente.appName + ' - Bem Vindo!'}
                exact
                path='/'
                component={NovoCadastroPage}
              />
              <Route path={'/convite-empresa/novo-usuario'} exact titulo='' component={ConviteUsuarioPage} />
              <Route
                path={'/:empresaId/login/:token'}
                titulo=''
                component={LoginRoute}
              />
              <Route
                path='/:empresaId'
                titulo=''
                component={LoginRoute}
              />
              <Route
                path='/:empresaId/pedido/:pedidoId'
                titulo=''
                component={LoginRoute}
              />
              <Route
                path='/:empresaId/:mesaId/mesa'
                titulo=''
                component={LoginRoute}
              />

              <Route path={'/:empresaId/configuracoes'} titulo='' component={LoginRoute} />
            </Switch>
            <DialogModaisPublic />

          </Notificacoes>
        </CapturarErros>
      </EmpresaTema>
    </PullToRefreshContainer>
  );
};
